import store from '../store/store';
import LimeAPI from '../classes/LimeAPI';
import { clearLoginReturnPath, clearPendingSign, clearSigningSession } from './signing-session';

export default () => {
  const abortsController = new AbortController();
  LimeAPI.delete(`authenticateUser/deleteUserSession/${store.getState().user.sessionToken}`, abortsController.signal)
    .then(() => localStorage.removeItem('orderRef'))
    .then(() => {
      clearPendingSign();
      clearSigningSession();
      clearLoginReturnPath();
      window.sessionStorage.removeItem('authId');
      window.sessionStorage.removeItem('userId');
    })
    .then(() => store.dispatch({ type: 'app/RESET_APP' }))
    .catch(() => false);
};
